import {
  Box,
  Heading,
  Text,
  Flex,
  FlexProps,
  StackProps,
  VStack,
} from "@chakra-ui/react";
import React from "react";

export function SectionHeader({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <Box w="full" mb={10}>
      <Heading as="h3" size="md" mb={description ? 2 : 0}>
        {title}
      </Heading>

      {description && (
        <Text maxW="40em" color="gray.600">
          {description}
        </Text>
      )}
    </Box>
  );
}

export function SectionContainer(props: FlexProps) {
  return (
    <Flex w="full" direction="column" alignItems="flex-start" {...props} />
  );
}

export function SettingsStack(props: StackProps) {
  return <VStack spacing={8} w="full" alignItems="flex-start" {...props} />;
}
